import theme from '@styles/theme';
import styled from 'styled-components';

export const CountWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    width: 100%;
    border-bottom: ${theme.colors.ultraLightGrayBorder} 1px solid;
`;
export const ChartSection = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 60px;
    padding: 30px 0;
`;
